import {
  findNodePath,
  getParentNode,
} from '@udecode/plate';

/**
 * Get table column index of a cell node.
 */
export const getTableColumnIndex = (
  editor,
  cellNode,
) => {
  const path = findNodePath(editor, cellNode);
  if (!path) return 0;

  const [trNode] = getParentNode(editor, path) ?? [];
  if (!trNode) return 0;

  let colIndex = 0;

  // Handles colspan in table. Allows increment of col index if a span comes before.
  let span = 0;

  trNode.children.some((item, index) => {
    if (item.colSpan && item.colSpan > 0) {
      span += item.colSpan - 1;
    }
    if (item === cellNode) {
      colIndex = index + span;
      return true;
    }
    return false;
  });

  return colIndex;
};
